import { useForm } from '@tanstack/vue-form';
import { onScopeDispose } from 'vue';

/**
 * Wraps TanStack's `useForm` to fix a cleanup bug.
 *
 * `useForm` calls `onMounted(formApi.mount)` but never captures the cleanup
 * function that `mount()` returns, so 6 internal subscriptions leak on every
 * unmount. This wrapper intercepts `mount()` and calls the cleanup via
 * `onScopeDispose`.
 */
/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any */
export const useFormWithCleanup = ((...args: any[]) => {
  const form = (useForm as any)(...args);

  const originalMount = form.mount.bind(form);
  let formCleanup: (() => void) | undefined;

  form.mount = () => {
    formCleanup = originalMount();

    return formCleanup;
  };

  onScopeDispose(() => {
    formCleanup?.();
  });

  return form;
}) as typeof useForm;
/* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any */
